import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import Dexef from "assets/images/svg/dexef_sympol.svg";
import Info from "assets/images/svg/info.svg";

const Footer = () => {
    const { t } = useTranslation();
    const currentYear = new Date();

    return (
        <div className="footer">
            <div className="container-fluid">
                <div className="footer-content">
                    <div className="leftSide">
                        <ul className="list-unstyled list">
                            <li>
                                <img src={Dexef} alt="Dexef" />
                            </li>
                            <li>
                                <Link to="/contact-us">{t("footer:contact")}</Link>
                            </li>
                            <li>
                                <Link to="/terms">{t("footer:privacy")}</Link>
                            </li>
                            <li>
                                <Link to="/terms">{t("footer:termsOfUse")}</Link>
                            </li>
                            <li>
                                <Link to="/">{t("footer:accessibility")}</Link>
                            </li>
                            <li>
                                <Link to="/">{t("footer:cookiePreferences")}</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="rightSide">
                        <p>
                        {t("footer:rightsLogo") } {currentYear.getFullYear()}{"©"}.
                            <img src={Info} alt="Info" />{" "}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
